export class DeleteTargetEspecificationsInput {
    targetEspecificationId: string;

    constructor(targetEspecificationId: string) {
        this.targetEspecificationId = targetEspecificationId;

    }
}